
export function button29_mouseIn(event) {$w("#box3").show();
	//Add your code for this event here: 
}

export function box3_mouseIn(event) {$w("#box3").show();
	//Add your code for this event here: 
}

export function button29_mouseOut(event) {$w("#box3").hide();
	//Add your code for this event here: 
}


export function box3_mouseOut(event) {$w("#box3").hide();
	//Add your code for this event here: 
}



export function box66_mouseOut(event) {$w("#box66").hide();
	//Add your code for this event here: 
}

export function button30_mouseIn(event) {$w("#box66").show();
	//Add your code for this event here: 
}

export function box66_mouseIn(event) {$w("#box66").show();
	//Add your code for this event here: 
}


export function button30_mouseOut(event) {$w("#box66").hide();
	//Add your code for this event here: 
}